import React , { useState, useEffect }from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Updated import
import Header from './components/header';
import Home from './components/home'; 
import Footer from './components/footer';
import Preloader from './components/Preloader';
import Booking from './components/booking';

function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading phase (e.g., waiting for data or resources)
    setTimeout(() => {
      setLoading(false); // After 3 seconds, set loading to false
    }, 3000);
  }, []);


  return (
    <Router>
      <div className="App">
      {loading && <Preloader />} 
        <Header />
        <Booking />
        <Routes> 
          <Route path="/" element={<Home />} />  
          {/* <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} /> */}
        </Routes>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
